import { STREETS, addressOf, LOCATIONS } from './dataset';

// Endpoints used by many pages (location and source pickers, filters).
// Location list for pickers and Listing Management. masterLocationId sends rows down the
// master-location branch, the only one that fills the name column.
const RATINGS = [4.6, 4.4, 4.8, 4.2, 4.5];
const REVIEW_COUNTS = [312, 248, 187, 156, 203];

const locationDoc = (loc, i) => {
	const s = STREETS[loc.locationId];
	const key = loc.locationId.slice(4);
	const site = `https://www.brightsidecoffee.com/locations/${key}`;
	return { ...loc,
		masterLocationId: loc.locationId,
		masterLocationName: `Brightside Coffee - ${loc.locationName}`,
		masterFriendlyName: loc.locationName,
		friendlyName: loc.locationName,
		masterAddress: {
			storeCode: loc.storeCode,
			...addressOf(loc)
		},
		address: addressOf(loc),
		openInfo: {
			status: 'OPEN'
		},
		locationState: {
			isVerified: true
		},
		avgStarRating: RATINGS[i],
		reviewCount: REVIEW_COUNTS[i],
		totalReviews: REVIEW_COUNTS[i],
		connections: ['google', 'yelp', 'facebook'],
		entityTags: [loc.state === 'WA' ? {
			filterTagId: 'grp-wa-cafes',
			filterTagName: 'Washington cafés'
		} : {
			filterTagId: 'grp-or-cafes',
			filterTagName: 'Oregon cafés'
		}],
		googleLocationId: [s.googleId],
		accountId: 'accounts/1029384756',
		websiteUrl: site,
		metadata: {
			placeId: `place-${key}`,
			mapsUrl: `https://maps.google.com/?q=Brightside+Coffee+${encodeURIComponent(loc.locationName)}`
		},
		healthScoring: {},
		customVariables: [],
		locationScoring: [],
		childLocations: [{
			source: 'google',
			locationId: s.googleId,
			locationName: `Brightside Coffee - ${loc.locationName}`,
			accountName: 'Brightside Coffee',
			phoneNumbers: {
				primaryPhone: s.phone
			},
			websiteUrl: site,
			metadata: {
				placeId: `place-${key}`
			},
			primaryCategory: {
				displayName: 'Coffee shop'
			},
			profile: {
				description: 'Small-batch roasts, house-made pastries and a sunny patio.'
			}
		}]
	};
}; // Saved filters: Manage Roles maps over the response as a list, Filter Composer reads { hits, total },
// and the Reviews page reads filterTagId / filterTagName / filters. A list carrying hits/total serves all three.


const SAVED_FILTERS = [{
	filterTagId: 'ft-wa-stores',
	filterTagName: 'Washington stores',
	accessType: 'TEAM',
	filters: {
		locationFilters: {
			locationIds: ['loc-riverside', 'loc-harbour'],
			country: 'US',
			area: 'WA'
		}
	}
}, {
	filterTagId: 'ft-or-stores',
	filterTagName: 'Oregon stores',
	accessType: 'TEAM',
	filters: {
		locationFilters: {
			locationIds: ['loc-northgate', 'loc-westfield'],
			country: 'US',
			area: 'OR'
		}
	}
}, {
	filterTagId: 'ft-low-ratings',
	filterTagName: 'Low ratings',
	accessType: 'PERSONAL',
	filters: {
		reviewFilters: {
			starRatingFilter: {
				ratingValues: [1, 2]
			}
		},
		sources: ['google', 'yelp']
	}
}];
export default {
	'/getFilterTags': () => Object.assign(SAVED_FILTERS.slice(), {
		hits: SAVED_FILTERS,
		total: SAVED_FILTERS.length
	}),
	'/getLocations': () => ({
		docs: LOCATIONS.map(locationDoc),
		total: LOCATIONS.length
	}),
	// Most callers map over a list of source keys; the Reviews page source picker reads `options`.
	'/getSources': () => Object.assign(['google', 'facebook', 'yelp', 'tripadvisor'], {
		status: 200,
		options: [{
			label: 'Google',
			value: 'google'
		}, {
			label: 'Facebook',
			value: 'facebook'
		}, {
			label: 'Yelp',
			value: 'yelp'
		}, {
			label: 'Tripadvisor',
			value: 'tripadvisor'
		}]
	}),
	// Review categories: a list of names (Reports, Automations, ReviewsInbox™ categories).
	'/getReviewTags': () => Object.assign(['Coffee quality', 'Service speed', 'Staff friendliness', 'Cleanliness', 'Pricing', 'Seating'], {
		status: 200
	})
};